import { View } from "./View";

export const DotSeparator = () => {
  return <View />;
};
